var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastrAct1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.55 1.77L16.43 2.94L16.38 3.4L16.36 3.63L16.29 4.24L16.27 4.44L16.22 4.89L16.1 6.06C16.03 6.75 15.44 7.27 14.75 7.27H7.68C6.98 7.27 6.4 6.75 6.33 6.06L6.21 4.88L6.16 4.43V4.41L6.07 3.63L6.04 3.4L6.01 3.1L5.87 1.77L7.11 2.84L8.01 3.63L8.04 3.66L8.34 3.92L8.55 3.63L8.81 3.28L9.17 2.8L11.21 0L13.26 2.8L13.53 3.17L13.87 3.63L14.09 3.92L14.4 3.65L14.42 3.63L15.37 2.81L16.55 1.77Z",
    fill: "url(#paint0_linear_21_350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.55 1.77L16.43 2.94L16.38 3.4L16.36 3.63L16.29 4.24L16.27 4.44L16.22 4.89L16.1 6.06C16.03 6.75 15.44 7.27 14.75 7.27H7.68C6.98 7.27 6.4 6.75 6.33 6.06L6.21 4.88L6.16 4.43V4.41L6.07 3.63L6.04 3.4L6.01 3.1L5.87 1.77L7.11 2.84L8.01 3.63L8.04 3.66L8.34 3.92L8.55 3.63L8.81 3.28L9.17 2.8L11.21 0L13.26 2.8L13.53 3.17L13.87 3.63L14.09 3.92L14.4 3.65L14.42 3.63L15.37 2.81L16.55 1.77Z",
    fill: "url(#paint1_linear_21_350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.46 3.63H18.27L18.25 3.79L18.11 5.1L17.99 6.25C17.82 7.92 16.43 9.17 14.75 9.17H7.68C6 9.17 4.61 7.92 4.44 6.25L4.26 4.52L4.16 3.64L3.96 3.63C1.61 4.84 0 7.29 0 10.12V18.67C0 22.7 3.28 25.98 7.3 25.98H15.12C19.15 25.98 22.42 22.7 22.42 18.67V10.12C22.42 7.29 20.81 4.84 18.46 3.63ZM12.05 20.25H4.9C4.4 20.25 4 19.85 4 19.35C4 18.85 4.4 18.45 4.9 18.45H12.05C12.54 18.45 12.95 18.85 12.95 19.35C12.95 19.85 12.54 20.25 12.05 20.25ZM17.53 16.04H4.9C4.4 16.04 4 15.63 4 15.14C4 14.65 4.4 14.24 4.9 14.24H17.53C18.03 14.24 18.43 14.64 18.43 15.14C18.43 15.64 18.03 16.04 17.53 16.04ZM17.53 12.23H4.9C4.4 12.23 4 11.83 4 11.33C4 10.83 4.4 10.43 4.9 10.43H17.53C18.03 10.43 18.43 10.84 18.43 11.33C18.43 11.82 18.03 12.23 17.53 12.23Z",
    fill: "url(#paint2_linear_21_350)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_350",
    x1: 5.87,
    y1: 3.64,
    x2: 16.55,
    y2: 3.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39DEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F8AF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_350",
    x1: 5.87,
    y1: 3.64,
    x2: 16.55,
    y2: 3.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39DEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F8AF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_350",
    x1: 0,
    y1: 14.81,
    x2: 22.42,
    y2: 14.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.42,
    height: 25.98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastrAct1);
export default __webpack_public_path__ + "static/media/MastrAct_1.29d08d053a252d9cb8f96724582eec02.svg";
export { ForwardRef as ReactComponent };